var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',_vm._l((_vm.header),function(header,$index){return _c('th',{key:$index,attrs:{"header":header}},[_c('td',{staticClass:"sortable"},[_vm._v(_vm._s(header.identifier))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }